/**
 * A QR (WhatsApp linked by QR) send the server REFUSES on purpose -- the number is resting after a burst, has reached its
 * daily cap, is not connected, and so on. The server answers these with an application error body
 * ({ success:false, code:"BAILEYS_...", message }) -- some of them with HTTP 503. They are not a server outage, so the
 * global network error handler must keep the real message and code instead of replacing them with the generic
 * "Server is temporarily unavailable" (which also made the per-attempt notices in the send flow impossible).
 */

// One toast id per condition, so the live socket notice, the global handler and the send flow all update ONE toast
// instead of stacking. Other BAILEYS_ refusals share a single fallback id.
const QR_REFUSAL_TOAST_IDS = {
  BAILEYS_BURST_PAUSE_ACTIVE: "whatsapp-qr-burst-pause",
  BAILEYS_DAILY_LIMIT_EXCEEDED: "whatsapp-qr-daily-limit",
};
const QR_REFUSAL_FALLBACK_TOAST_ID = "whatsapp-qr-send-refused";

// A Meta WhatsApp send for a workspace whose Meta number is not connected is refused the same way (server code below): one clear
// notice, never the generic "server unavailable" text or a second message at the top of the chat.
export const WHATSAPP_NOT_CONNECTED_CODE = "WHATSAPP_NOT_CONNECTED";
QR_REFUSAL_TOAST_IDS[WHATSAPP_NOT_CONNECTED_CODE] = "whatsapp-channel-not-connected";
QR_REFUSAL_TOAST_IDS.BAILEYS_NUMBER_NOT_CONNECTED = "whatsapp-qr-number-not-connected";

/** True for an application refusal body from a WhatsApp send path -- QR (BAILEYS_*) or a Meta channel that is not connected (never for an HTML/gateway body). */
export function isQrSendRefusal(body) {
  return (
    Boolean(body) &&
    typeof body === "object" &&
    typeof body.code === "string" &&
    (body.code.startsWith("BAILEYS_") || body.code === WHATSAPP_NOT_CONNECTED_CODE)
  );
}

export const qrRefusalToastId = (code) => QR_REFUSAL_TOAST_IDS[code] || QR_REFUSAL_FALLBACK_TOAST_ID;
